import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import City from "./City";
import Counter from "./Counter";
import Experience from "./Experience";
import Featured from "./Featured";
import PropertyHomeSection from "./PropertyHomeSection";
import Service from "./Service";
import Team from "../common/Team";
import { FeaturedProperties, RecentlyAddedProperties } from "../../../constants";
import Categories from "../common/Categories";
import Testimonials from "../common/Testimonials";
import SearchModal from "../../commonComponents/modals/SearchModal";

const PropertyDemo2Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <PropertyHomeSection />
      <Categories type={"property_demo2"} />
      <Featured title={FeaturedProperties} data={[41, 42, 43]} label="Featured" />
      <Experience />
      <Featured title={RecentlyAddedProperties} data={[44, 45, 46]} label="New" />
      <Service />
      <City />
      <Counter />
      <Testimonials type="property_demo2" />
      <Team type="property_demo2" />
      <SearchModal type="property" />
    </>
  );
};

export default PropertyDemo2Container;
